import axios from 'axios'
import { Basket } from '../../../schema/basket'
import { getUrl, PAYMENT_WEBSHOP_URL } from '../../util/api/api'

const getBasket = () =>
  axios.get<Basket>(getUrl(`${PAYMENT_WEBSHOP_URL}/basket`), {
    withCredentials: true,
  })

export default getBasket
